import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex)


import baseData from './modules/baseData'//初始数据

export default new vuex.Store({
    modules: {
        baseData : baseData
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js